import workerUrl from './find-in-file.worker?worker&url'

export function createFindInFileWorker() {
  return new Worker(workerUrl, {type: 'module'})
}
